export const byClassName = (selector, ctx = document) => {
  Array.toArray(ctx.getElementsByClassName(selector));
};

export const qs = (selector, ctx = document) => ctx.querySelector(selector);

export const qsa = (selector, ctx = document) => Array.from(ctx.querySelectorAll(selector));

export const getData = (attr, ctx) => ctx.hasAttribute('data-' + attr) ? ctx.getAttribute('data-' + attr) : '';

export function inViewport(element) {
  const rect = element.getBoundingClientRect();
  const html = document.documentElement;

  return (rect.top >= 0 && rect.top < html.clientHeight) ||
    (rect.bottom >= 0 && rect.bottom < html.clientHeight);
}

const getDevice = () => {
  let device = window.getComputedStyle(document.body, '::after').getPropertyValue('content');
  device = device.replace(/('|")/g, '');

  return device;
};

export function loadImage(url) {
  return new Promise(function (resolve, reject) {

    var img = new Image();
    img.src = url;

    img.onload = function () {
      resolve(img);
    }

    img.onerror = function () {
      reject(url);
    }

  })
}

export function loadImages(imagesObject) {

  let imagesLength = imagesObject.length
  let imagesLoaded = 0

  return new Promise(function (resolve, reject) {
    Object.keys(imagesObject).map((key, index) => {
      const img = new Image();
      img.src = imagesObject[key];

      img.onload = function () {
        imagesLoaded++

        if (imagesLoaded === imagesLength) {
          resolve("Images loaded");
        }
      }
    })

    // reject(url);
  })
}

export function getParam(param) {
  var result = null,
    tmp = [];

  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
    });

  if (result === 'undefined') {
    return null
  } else {
    return result
  }
}

export function setParam(key, value) {
  key = encodeURIComponent(key);
  value = encodeURIComponent(value);

  var kvp = window.location.search.substr(1).split('&')
  let i = 0

  for (; i < kvp.length; i++) {
    if (kvp[i].startsWith(key + '=')) {
      let pair = kvp[i].split('=');
      pair[1] = value;
      kvp[i] = pair.join('=');
      break;
    }
  }

  if (i >= kvp.length) {
    kvp[kvp.length] = [key, value].join('=');
  }

  let params = kvp.join('&');

  window.history.replaceState(null, null, `?${params}`);
}

export function removeParams(key) {
  const sourceURL = location.protocol + '//' + location.host + location.pathname
  window.history.replaceState(null, null, sourceURL)
}

export function removeParam(key) {
  const sourceURL = location.protocol + '//' + location.host + location.pathname
  var urlparts = window.location.search.split('?')

  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(key) + '='
    var pars = urlparts[1].split(/[&;]/g)

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    window.history.replaceState(null, null, sourceURL + urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''))
  }
}

export function isMobile() {
  return !(getDevice() !== 'xxs' && getDevice() !== 'xs');
}

export function isTablet() {
  return !(getDevice() !== 'sm');
}

export function isIOS() {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }
}

export function isMobileSafari() {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iP(ad|hone)/i);
  const webkit = !!ua.match(/WebKit/i);
  const iOSSafari = iOS && webkit && !/(Chrome|CriOS|OPiOS)/.test(ua);

  return iOSSafari;
}

export function isSafari() {
  return (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
}

export function isEdge() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  return false;
}

export function isIE() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  return false;
}

export function browser() {
  var ua = navigator.userAgent,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}

export function lerp(a, b, n) {
  return ((1 - n) * a) + (n * b);
}

export function viewportSize() {
  const coords = {
    width: window.innerWidth,
    height: window.innerHeight,
    ratio: window.innerWidth / window.innerHeight,
  };

  return coords;
}

export function roundDec(n) {
  return Math.round(n * 100) / 100;
}

export function getDegrees(radians) {
  return (radians * 180) / Math.PI;
};

export function getRadians(degrees) {
  return (degrees * Math.PI) / 180;
};

export function getRandom(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function devices() {
  let check = false;

  // if (navigator.userAgent.match(/Android/i)
  //   || navigator.userAgent.match(/webOS/i)
  //   || navigator.userAgent.match(/iPhone/i)
  //   || navigator.userAgent.match(/iPad/i)
  //   || navigator.userAgent.match(/iPod/i)
  //   || navigator.userAgent.match(/BlackBerry/i)
  //   || navigator.userAgent.match(/Windows Phone/i)) {
  //   check = true;
  // } else {
  //   check = false;
  // }

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export function siblings(n) {
  return [...n.parentElement.children].filter(c => c !== n);
}

export function decodeHTML(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export function fetchData(to, from, next) {
  const theme = store.state.layouts.find(el => el.id === to.params.theme);
  const currentPage = store.state.pages.find(el => {
    const id = (to.params.newsName !== undefined) ? `${to.params.theme}-${to.params.newsName}-${to.params.lang}` : `${to.params.theme}-${to.params.page}-${to.params.lang}`
    return el.id === id;
  });

  if (store.state.lang !== to.params.lang) {
    store.commit('CHANGE_LANG', to.params.lang);
    if (store.state.layouts.length > 0 && theme !== undefined) {
      store.commit('SET_LAYOUT', to.params.theme);
    }
  }
  if (store.state.theme === '' || from.params.theme !== to.params.theme) store.commit('CHANGE_THEME', to.params.theme);

  if (store.state.layouts.length > 0 && from.params.theme !== to.params.theme && theme !== undefined) {
    store.commit('SET_LAYOUT', to.params.theme);
  } else if (from.params.theme !== to.params.theme && theme === undefined) {
    store.dispatch('FETCH_LAYOUT', to.params.theme);
  }

  if (store.state.pages.length > 0 && currentPage !== undefined) {
    store.commit('SET_DATAPAGE', currentPage.data);
    next();
  } else if (to.params.newsName !== undefined) {
    store.dispatch('FETCH_NEWS', to.params).then((res) => {
      if (!res) router.push('/');
      else next();
    });
  } else {
    store.dispatch('FETCH_PAGE', to.params).then((res) => {
      if (!res) router.push('/');
      else next();
    });
  }
}

// trigger DOMContentLoaded
function scriptsDone() {
  var DOMContentLoadedEvent = document.createEvent('Event')
  DOMContentLoadedEvent.initEvent('DOMContentLoaded', true, true)
  document.dispatchEvent(DOMContentLoadedEvent)
}

// runs an array of async functions in sequential order
function seq(arr, callback, index) {
  // first call, without an index
  if (typeof index === 'undefined') {
    index = 0
  }

  arr[index](function () {
    index++
    if (index === arr.length) {
      callback()
    } else {
      seq(arr, callback, index)
    }
  })
}

function insertScript($script, callback) {
  var s = document.createElement('script')
  s.type = 'text/javascript'
  if ($script.src) {
    s.onload = callback
    s.onerror = callback
    s.src = $script.src
  } else {
    s.textContent = $script.innerText
  }

  // re-insert the script tag so it executes.
  document.head.appendChild(s)

  // clean-up
  $script.parentNode.removeChild($script)

  // run the callback immediately for inline scripts
  if (!$script.src) {
    callback()
  }
}

// https://html.spec.whatwg.org/multipage/scripting.html
var runScriptTypes = [
  'application/javascript',
  'application/ecmascript',
  'application/x-ecmascript',
  'application/x-javascript',
  'text/ecmascript',
  'text/javascript',
  'text/javascript1.0',
  'text/javascript1.1',
  'text/javascript1.2',
  'text/javascript1.3',
  'text/javascript1.4',
  'text/javascript1.5',
  'text/jscript',
  'text/livescript',
  'text/x-ecmascript',
  'text/x-javascript'
]

export function runScripts($container) {
  // get scripts tags from a node
  var $scripts = $container.querySelectorAll('script')
  var runList = []
  var typeAttr

  [].forEach.call($scripts, function ($script) {
    typeAttr = $script.getAttribute('type')

    // only run script tags without the type attribute
    // or with a javascript mime attribute value
    if (!typeAttr || runScriptTypes.indexOf(typeAttr) !== -1) {
      runList.push(function (callback) {
        insertScript($script, callback)
      })
    }
  })

  // insert the script tags sequentially
  // to preserve execution order
  seq(runList, scriptsDone)
}

// fade out pure javascript
export function fadeOut(el, duration) {
  var fadeEffect = setInterval(function () {
    if (!el.style.opacity) {
      el.style.opacity = 1;
    }
    if (el.style.opacity > 0) {
      el.style.opacity -= 0.1;
    } else {
      clearInterval(fadeEffect);
    }
  }, duration);
}

// fade in pure javascript
export function fadeIn(el, duration) {
  var fadeEffect = setInterval(function () {
    if (!el.style.opacity) {
      el.style.opacity = 0;
    }
    if (el.style.opacity < 1) {
      el.style.opacity = Number(el.style.opacity) + 0.1;
    } else {
      clearInterval(fadeEffect);
    }
  }, duration);
}